module.exports = __webpack_public_path__ + "static/media/box-view.1af38702.svg";